import {
    FETCH_COLLECTION_SET,
    ORDER_COLLECTION_SET,
    FETCH_ANALYSIS_PACKAGES,
    FETCH_SURVEY_ANSWERS,
    SAVE_SURVEY_ANSWERS,
    FETCH_COUNTRIES,
    FETCH_CONSULTATION_LIST,
    BOOK_CONSULTATION,
    CANCEL_CONSULTATION,
    ORDER_ANALYSIS
} from "../actions";
import {ShopService} from "../../common/api.service";
import {
    SET_COLLECTION_SET,
    SET_PAYMENT_CHECKSUM,
    SET_ORDER_NUMBER,
    SET_PACKAGES,
    SET_SURVEY,
    SET_COUNTRIES
} from "../mutations";

const state = {
    collection_set: [],
    shop_id: 742453,
    payment_checksum: '',
    order_number: '',
    analysis_packages: [],
    survey: '',
    countries: []
}

const mutations = {
    [SET_COLLECTION_SET](state, payload) {
        state.collection_set = payload;
        state.collection_set_count = 1;
    },
    [SET_PAYMENT_CHECKSUM](state, payload) {
        state.payment_checksum = payload;
    },
    [SET_ORDER_NUMBER](state, payload) {
        state.order_number = payload;
    },
    [SET_PACKAGES](state, payload) {
        state.analysis_packages = payload;
    },
    [SET_SURVEY](state, payload) {
        state.survey = payload;
    },
    [SET_COUNTRIES](state, payload) {
        state.countries = payload;
    }
}

const getters = {
    collection_set(state) {
        return state.collection_set;
    },
    collection_set_count(state) {
        return state.collection_set_count;
    },
    shop_id(state) {
        return state.shop_id;
    },
    payment_checksum(state) {
        return state.payment_checksum;
    },
    order_number(state) {
        return state.order_number;
    },
    analysis_packages(state) {
        return state.analysis_packages;
    },
    survey(state) {
        return state.survey;
    },
    countries(state) {
        return state.countries;
    }
}

const actions = {
    [FETCH_COLLECTION_SET](context) {
        ShopService.getCollectionSet().then(
            function (response) {
                context.commit(SET_COLLECTION_SET, response.data);
            });
    },
    [ORDER_COLLECTION_SET](context, payload) {
        ShopService.orderCollectionSet(payload).then(
            function (response) {
                context.commit(SET_PAYMENT_CHECKSUM, response.data.payment_checksum);
                context.commit(SET_ORDER_NUMBER, response.data.number);
            }
        )
    },
    [FETCH_ANALYSIS_PACKAGES](context, payload) {
        ShopService.getPackages(payload).then(
            function (response) {
                context.commit(SET_PACKAGES, response.data);
            }
        )
    },
    [FETCH_SURVEY_ANSWERS](context, payload) {
        return ShopService.getSurvey(payload);
    },
    [SAVE_SURVEY_ANSWERS](context, payload) {
        ShopService.saveSurvey(payload);
    },
    [FETCH_COUNTRIES](context, payload) {
        ShopService.getCountries(payload).then(
            function (response) {
                context.commit(SET_COUNTRIES, response.data);
            }
        )
    },
    [FETCH_CONSULTATION_LIST](context, payload) {
        return ShopService.getConsultations(payload)
    },
    [BOOK_CONSULTATION](context, payload) {
        return ShopService.bookConsultation(payload)
    },
    [CANCEL_CONSULTATION](context, payload) {
        return ShopService.cancelConsultation(payload)
    },
    [ORDER_ANALYSIS](context, payload) {
        return ShopService.orderAnalysis(payload)
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/shop.js